import { z } from 'zod';

export const LifecycleStateFilterSchema = z.enum(['active', 'archived', 'all']);

export type LifecycleStateFilterDto = z.infer<
  typeof LifecycleStateFilterSchema
>;

const AssetLifecycleStateSchema = z.enum(['ACTIVE', 'ARCHIVED']);
const AssetLifecycleOriginSchema = z.enum(['SCOPING', 'MANUAL', 'CODE']);

export const AssetLifecycleDtoSchema = z.object({
  state: AssetLifecycleStateSchema,
  origin: AssetLifecycleOriginSchema.nullable(),
});

export type AssetLifecycleDto = z.infer<typeof AssetLifecycleDtoSchema>;

export const DEFAULT_ASSET_LIFECYCLE_DTO: AssetLifecycleDto = {
  state: 'ACTIVE',
  origin: null,
};

const AssetLifecycleInputSchema = z.object({
  state: AssetLifecycleStateSchema,
  origin: AssetLifecycleOriginSchema.nullish(),
});

export const toAssetLifecycleDto = (lifecycle: unknown): AssetLifecycleDto => {
  const parsed = AssetLifecycleInputSchema.safeParse(lifecycle);

  if (!parsed.success) {
    return DEFAULT_ASSET_LIFECYCLE_DTO;
  }

  return {
    state: parsed.data.state,
    origin: parsed.data.origin ?? null,
  };
};

export const isArchivedLifecycle = (
  lifecycle: { state: string } | null | undefined,
): boolean => lifecycle?.state === 'ARCHIVED';

export const isCodeDeletedLifecycle = (
  lifecycle: { state: string; origin?: string | null } | null | undefined,
): boolean => lifecycle?.state === 'ARCHIVED' && lifecycle.origin === 'CODE';
